import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen } from "lucide-react";
import api, { formatNGN } from "../lib/api";
import useSEO from "../lib/useSEO";

export default function Publications() {
    useSEO({ title: "Publications & Bookstore", description: "Two-volume treatises by Rotimi Jacobs, SAN — Criminal Procedure & Evidence. Available in hardcover and digital.", path: "/publications" });
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/publications").then(({ data }) => {
            setItems(data);
            setLoading(false);
        }).catch(() => setLoading(false));
    }, []);

    return (
        <div data-testid="page-publications">
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-24">
                <div className="font-mono-cap text-xs text-[#c5a059] mb-3 flex items-center gap-2">
                    <BookOpen className="w-3.5 h-3.5" /> Publications
                </div>
                <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-tight">
                    Treatises by the Principal Partner.
                </h1>
                <p className="mt-6 max-w-2xl text-slate-800 leading-relaxed text-[17px]">
                    Authoritative two-volume works on the Administration of Criminal Justice Act and the Evidence Act —
                    available in hardcover and digital formats. Order below; shipping is offered across Nigeria with
                    digital downloads delivered immediately after payment.
                </p>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
                {loading ? (
                    <div className="font-mono-cap text-xs text-slate-500">Loading…</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16">
                        {items.map((b) => (
                            <article
                                key={b.id}
                                className="border border-slate-900/10 bg-[#faf9f6] flex flex-col md:flex-row overflow-hidden"
                                data-testid={`publication-card-${b.id}`}
                            >
                                <div className="md:w-2/5 bg-[#f3f1ea]">
                                    <img src={b.cover_url} alt={b.title} className="w-full h-full object-cover" />
                                </div>
                                <div className="p-7 md:w-3/5 flex flex-col">
                                    <div className="font-mono-cap text-[11px] text-[#c5a059]">{b.category}</div>
                                    <h2 className="font-serif-display text-2xl md:text-3xl text-slate-900 mt-2 leading-tight">
                                        {b.title}
                                    </h2>
                                    <div className="text-sm text-slate-600 mt-1 italic">{b.author}</div>
                                    <p className="mt-4 text-[15px] text-slate-800 leading-relaxed flex-1">
                                        {b.description.slice(0, 180)}…
                                    </p>
                                    <div className="mt-6 flex items-center justify-between">
                                        <div className="font-serif-display text-2xl text-slate-900">
                                            {formatNGN(b.price_ngn)}
                                        </div>
                                        <Link
                                            to={`/publications/${b.id}`}
                                            className="inline-flex items-center gap-2 bg-[#0F172A] text-[#faf9f6] px-5 py-2.5 rounded-sm text-sm hover:bg-[#c5a059] hover:text-[#0F172A] transition-colors"
                                            data-testid={`publication-view-${b.id}`}
                                        >
                                            View &amp; Order <ArrowUpRight className="w-4 h-4" />
                                        </Link>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}
